export enum MonthlyPayment {
  SEPA = 'SEPA',
  DIRECT_DEBIT = 'Direct Debit',
}
